import React, { useEffect, useState } from "react";
import "./FIIDIIHistoryData.css";
import { environment } from "environment/environment";
import useStockApiWebsocket from "service/websocket/StockApiWebsocket";
import DatePicker from "react-datepicker";
import axios from "axios";

export default function FIIDIIHistoryData() {

    const [keyDateList, setKeyDateList] = useState([]);
    const [historyData, setHistoryData] = useState([]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const summaryRes = await getFiiDiiSummary();
                const keySummarDateData = summaryRes?.data?.data?.key_list;

                const sortedDates = sortMonthYearDesc(keySummarDateData);

                setKeyDateList(sortedDates);

                console.log("summaryRes", sortedDates);

                // ✅ use sortedDates directly (NOT state)
                if (sortedDates.length > 0) {
                    const historyResponseData = await fetchHistoryDataByMonth(sortedDates[0]);

                    const historyData = historyResponseData?.data?.data;
                    const formattedData = Object.values(historyData);
                    console.log("Initial History Data", formattedData);
                    const sortedData = formattedData.sort(
                        (a, b) => new Date(b.date) - new Date(a.date)
                    );
                    console.log("Initial History sortedData", sortedData[1]);
                    const historyArray = Object.values(sortedData[1]);
                    const finalHistoryData = historyArray.sort(
                        (a, b) => new Date(b.date) - new Date(a.date)
                    );
                    console.log("Initial History finalHistoryData", finalHistoryData);
                    setHistoryData(finalHistoryData);
                }


            } catch (err) {
                console.error(err);
            }
        };

        fetchData();


    }, []);

    const handleMonthChange = async (e) => {
        const selectedMonth = e.target.value;

        console.log("Selected Month:", selectedMonth);

        const historyResponseData = await fetchHistoryDataByMonth(selectedMonth);

        const historyData = historyResponseData?.data?.data;
        const formattedData = Object.values(historyData);
        console.log("Initial History Data", formattedData);
        const sortedData = formattedData.sort(
            (a, b) => new Date(b.date) - new Date(a.date)
        );
        console.log("Initial History sortedData", sortedData[1]);
        const historyArray = Object.values(sortedData[1]);
        const finalHistoryData = historyArray.sort(
            (a, b) => new Date(b.date) - new Date(a.date)
        );
        console.log("Initial History handleMonthChange", finalHistoryData);
        setHistoryData(finalHistoryData);
    };

    const getFiiDiiSummary = async () => {
        return await axios.get(
            `${environment.stockApiBaseUrl}/fiidii-data/summary-data`
        );
    };
    const fetchHistoryDataByMonth = async (monthYear) => {
        try {

            return await axios.get(
                `${environment.stockApiBaseUrl}/fiidii-data/history-year-month?yearMonth=${monthYear}`
            );


        } catch (error) {
            console.error("Error fetching history data:", error);
        }
    };
    const formatMonthYear = (dateString) => {
        if (!dateString) return "";

        const date = new Date(dateString);

        return date.toLocaleString("en-US", {
            month: "long",
            year: "numeric",
        });
    };

    const sortMonthYearDesc = (data) => {
        return [...data].sort((a, b) => {
            const [yearA, monthA] = a.split("-");
            const [yearB, monthB] = b.split("-");

            const dateA = new Date(`${monthA} 1, ${yearA}`);
            const dateB = new Date(`${monthB} 1, ${yearB}`);

            return dateB - dateA; // 🔥 descending
        });
    };

    const formatValue = (value) => {
    if (value == null || isNaN(value)) return "--";

    const num = Number(value);
    const absNum = Math.abs(num);
    const sign = num < 0 ? "-" : "";

    // 🔥 Detect percentage (if value is between -100 and 100 and has decimals)
    if (absNum <= 100 && !Number.isInteger(num)) {
        return `${num.toFixed(2)}%`;
    }

    // 🔥 Crore (>= 1 Cr)
    if (absNum >= 10000000) {
        const crValue = Math.trunc(absNum / 10000000);
        return `${sign}${crValue} CR`;
    }

    // 🔥 Lakh (>= 1 Lakh)
    if (absNum >= 100000) {
        const lakhValue = absNum / 100000;
        return `${sign}${lakhValue.toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })} L`;
    }

    // 🔥 Whole number (no decimal)
    if (Number.isInteger(num)) {
        return `${sign}${absNum.toLocaleString("en-IN")}`;
    }

    // 🔥 Default (Indian format with 2 decimal)
    return `${sign}${absNum.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })}`;
};

    return (
        <div className="history-table-container">
            <div className="fiidii-history-header">
                <h2 className="fiidii-history-heading">
                    <span className="sectorial-indices-span">FII & DII HISTORY DATA</span>


                    {/* ✅ SIMPLE DROPDOWN FROM keyDateList */}
                    <select onChange={handleMonthChange}>
                        {keyDateList.map((date, index) => (
                            <option key={index} value={date}>
                                {formatMonthYear(date)}
                            </option>
                        ))}
                    </select>
                </h2>
            </div>
            <table className="responsive-table table-bordered text-center sticky-header">

                <thead>
                    {/* 🔥 TOP HEADER */}
                    <tr>
                        <th rowSpan="2">DATE</th>
                        <th rowSpan="2">NIFTY</th>

                        <th colSpan="2">OPTIONS</th>
                        <th colSpan="4">FUTURES</th>
                        <th colSpan="2">CASH</th>
                    </tr>

                    {/* 🔥 SECOND HEADER */}
                    <tr>
                        {/* OPTIONS */}
                        <th>FII CALL OI CHG</th>
                        <th>FII PUT OI CHG</th>

                        {/* FUTURES */}
                        <th>BUY/SELL (Amt)</th>
                        <th>OI Change(Qty)</th>
                        <th>VIEW</th>
                        <th>OI</th>

                        {/* CASH */}
                        <th>FII CASH</th>
                        <th>DII CASH</th>
                    </tr>
                </thead>

                <tbody>
                    {historyData.map((item) => (
                        <tr key={item.date}>
                            <td>{item.date}</td>
                            <td>
                                {formatValue(item.nifty)}
                                <span
                                    className={`positive-negative 
                                        ${item.nifty_change_percent >= 0 ? "positive" : "negative"}`} >
                                    {formatValue(item.nifty_change_percent)}
                                </span>
                            </td>
                            <td>{formatValue(item.option.fii.call.net_oi_change)}
                                <span className={`positive-negative 
                                        ${item.option.fii.call.net_oi_change_view === 'BULLISH' ? "positive" : "negative"}`}  >
                                    {item.option.fii.call.net_oi_change_view}
                                </span>
                            </td>
                            <td>{formatValue(item.option.fii.put.net_oi_change)}
                                <span className={`positive-negative 
                                        ${item.option.fii.put.net_oi_change_view === 'BULLISH' ? "positive" : "negative"}`}  >
                                    {item.option.fii.put.net_oi_change_view}
                                </span>
                            </td>
                            <td>
                                {formatValue(item.future?.fii?.["amount-wise"]?.net_oi)} Cr
                            </td>
                            <td>
                                {formatValue(item.future?.fii?.["quantity-wise"]?.net_oi)}
                            </td>
                            <td>
                                <span className={`positive-negative 
                                        ${item.future?.fii?.["quantity-wise"]?.net_view === 'BULLISH' ? "positive" : "negative"}`}  >
                                    {item.future?.fii?.["quantity-wise"]?.net_view}
                                </span>
                            </td>
                            <td>
                                {formatValue(item?.future?.fii?.futures_outstanding_oi)}
                            </td>
                            <td>
                                {formatValue(item?.cash?.fii?.buy_sell_difference)} Cr
                                <span className={`positive-negative 
                                        ${item?.cash?.fii?.net_view === 'BULLISH' ? "positive" : "negative"}`}  >
                                    {item.cash?.fii?.net_view}
                                </span>

                            </td>
                            <td>
                                {formatValue(item?.cash?.dii?.buy_sell_difference)} Cr
                            </td>
                        </tr>
                    ))}
                </tbody>

            </table>
        </div>
    );
}